<template>
  <div class="tourn-card row row-cols-1 row-cols-md-2 row-cols-xxl-4 g-4 gy-5">
    <template v-for="(item, index) in tournamentlist">
      <div class="col" :key="index">
        <router-link
          :to="{
            name: 'Condition',
            params: {
              id:
                item.tournamentno,
              gametype_fk:
                item.gametype_fk,
              participationtype_fk:
                item.participationtype_fk,
            },
          }"
        >
          <div class="card h-100">
            <div class="card-img-wrapper">
              <!-- <div class="image" :style="{ backgroundImage: `url(${get_img('https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg')})` }"></div> -->
              <img
                :src="
                  item.tourbinary &&
                  item.tourbinary[0] &&
                  item.tourbinary[0].filepath_web
                    | get_img(
                      'https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                    )
                "
              />
            </div>
            <div class="card-body">
              <p class="badge-group">
                <span class="badge tourn-type">
                  {{ tournament_type(item.tourtype_fk) }}
                </span>
                <span class="badge tourn-game-type">
                  {{ game_type(item.gametype_fk) }}
                </span>
              </p>
              <h5 class="tourn-title">{{ item.title }}</h5>
              <p class="tourn-rank-type">
                {{ item.tour_rank_type | tour_rank_type }}
              </p>
            </div>
            <div class="card-footer">
              <p
                class="text-date text-truncate"
                v-if="
                  item.timezone_startdate &&
                  item.timezone_startdate.timezone_private
                "
              >
                <dfn
                  class="time-zone-mark badge rounded-pill bg-orange"
                  title="Connect time"
                  >CT</dfn
                >
                {{ item.timezone_startdate.timezone_private | dateformat }}
                ~
                {{ item.timezone_enddate.timezone_private | dateformat }}
              </p>

              <!-- 서비스 시간 -->
              <p
                class="text-date text-truncate"
                v-else-if="
                  item.timezone_startdate &&
                  item.timezone_startdate.timezone_common
                "
              >
                <dfn
                  class="time-zone-mark badge rounded-pill bg-green"
                  title="Standard time"
                  >ST</dfn
                >
                {{ item.timezone_startdate.timezone_common | dateformat }}
                ~
                {{ item.timezone_enddate.timezone_common | dateformat }}
              </p>
            </div>
          </div>
        </router-link>
      </div>
    </template>
  </div>
</template>
<script>
import { myMixin } from "@/mixin/myMixin";
export default {
  name: "Tournament",
  props: ["tournamentlist"],
  mixins: [myMixin],
};

</script>
